export const DISPLAY_CENTER_SAVE_BUTTON = "DISPLAY_CENTER_SAVE_BUTTON";
export const DISPLAY_CENTERS_DROPDOWN_LIST = "DISPLAY_CENTERS_DROPDOWN_LIST";
export const DISPLAY_THEMES = "DISPLAY_THEMES";
export const DISPLAY_TIME_ZONES = "DISPLAY_TIME_ZONES";
export const SET_CAN_ADD_TAG = "SET_CAN_ADD_TAG";
export const SET_CAN_ASSIGN_TAG = "SET_CAN_ASSIGN_TAG";
export const SET_CAN_DELETE_TAG = "SET_CAN_DELETE_TAG";
export const SET_CARDS = "SET_CARDS";
export const SET_CARD_SELECTION = 'SET_CARD_SELECTION';
export const SET_IS_ADDING_TAG = "SET_IS_ADDING_TAG";
export const SET_IS_NEW_TOURNAMENT = "SET_IS_NEW_TOURNAMENT";
export const SET_LOCATION_CERTIFICATION_NUMBER = "SET_LOCATION_CERTIFICATION_NUMBER";
export const SET_STRIPE_ACCOUNT_SELECTION = 'SET_STRIPE_ACCOUNT_SELECTION';
export const SET_STRIPE_ACCOUNTS = 'SET_STRIPE_ACCOUNTS';
export const SET_TAG_INDEX = "SET_TAG_INDEX";
export const SET_AVAILABLE_TAGS = "SET_AVAILABLE_TAGS";
export const SET_TOURNAMENT_EXPORT_OPTIONS_IN_STATE = "SET_TOURNAMENT_EXPORT_OPTIONS_IN_STATE";
export const SET_TOURNAMENT_EXPORT_SELECTION_IN_STATE = "SET_TOURNAMENT_EXPORT_SELECTION_IN_STATE";
export const SET_TOURNAMENT_LOCATION_EDITING = "SET_TOURNAMENT_LOCATION_EDITING";
export const SET_TOURNAMENT_LOCATION_NAME_VALUE = "SET_TOURNAMENT_LOCATION_NAME_VALUE";
export const SET_TOURNAMENT_LOCATION_SEARCH_RESULTS = "SET_TOURNAMENT_LOCATION_SEARCH_RESULTS";
export const SET_TOURNAMENT_LOCATIONS_IN_STATE = "SET_TOURNAMENT_LOCATIONS_IN_STATE";
export const SET_TOURNAMENT_TAGS = "SET_TOURNAMENT_TAGS";
export const SET_IS_SUPER_USER = "SET_IS_SUPER_USER";



// WEBPACK FOOTER //
// ./src/features/tournament/general/constants.js